var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._l((_vm.rows),function(row,index){return _c('th',{key:("row-" + index),staticClass:"text-center"},[_vm._v(" "+_vm._s(row)+" ")])}),_c('th')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }